var _pattern, _clipPath, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinesButton(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 138,
    viewBox: "0 0 343 138",
    width: 300,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _pattern || (_pattern = /*#__PURE__*/React.createElement("pattern", {
    id: "a",
    height: 1,
    patternContentUnits: "objectBoundingBox",
    width: 1
  }, /*#__PURE__*/React.createElement("image", {
    height: 37,
    transform: "scale(.0416667 .027027)",
    width: 24,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAlCAYAAABYkymLAAACZElEQVRIibXX34tVVRjG8c8ZJ2381ZSFQz8wkyLCQDGVLjIqq5v0Ki9EgiCim/6P/o6uuyoS8kYUQcxUAi0qKSVtROkXaIyV4+PF2hNy2uectcczD2zYZ+29nu9+1/uud+/TS6JS92M9VuBn3KyZNFnrjik8g3X4tRYw0QGwEtuwGw/UTuoSwSo8i+cbWJW6RPAgNuBhrFkKwGMNYApPqYy+C2ADNipLtVmpqLEBppUKoqz/i3h8XIAeXsHWu8a24IlxAe7D60qJLmga2zEzDsALjXl/Ut/Cq/cKeBQfKLXfr+fwEh5aLGA19ipPOjXgnt3Yryxju5K0HRNJDiQ5n9H6OsmuJL02rzbzFUneS3KuwjxJbic5nGT7KMBEks1JPkryU6X5gm4lOZTkzcbnP99JPI1HlErZ1azr9LDEtWgZ3lC67CYcwkVK6e1QqmE/1nY07tdOpaVswSe4PYnruIbZBljdigdoBi/jAuZ7SVZjOZ5UyvJ9pf4Xo2s4gs9wEv/L+kySd5J8tYgkH0/yYZJNSZa3VdHC0UuyJ8nRSvO5poL2JVnb7zdoo0myN8k3FYAjSV5LMtnmMwwwleTdJFeHmJ9M8naSZYN8hvWiORxukvZPy/W/cBCfYn6QyahuOouP8X3LtYP4HP8OMxgFuIWj+K5vfA5f4PSI+VUvnJuN0S93jZ3F+Yq5VYB5nMC3ze8bytP/OC4AnFO2PiW5x3BlnIDf8HtzfgOXKud1+vBa+Jqexd9LAfhD6fE/LBXgKs40gLaNd8+AKzilYwRd/h9cxpdKJNURdAH8qeTguiG9p193AFuoocqiARjPAAAAAElFTkSuQmCC"
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m.75.875h342v137h-342z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m197.093 29.4979c67.915 30.0453 115.187 71.9651 105.585 93.6301s-72.442 14.872-140.358-15.172c-67.9151-30.0445-115.1876-71.9649-105.5853-93.63 9.6023-21.66513 72.4443-14.872483 140.3583 15.1719z",
    fillRule: "evenodd",
    stroke: "#e4e4e4",
    strokeWidth: 1.267
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m182.194 38.55c51.245-24.4847 99.134-31.08144 106.959-14.7354 7.825 16.346-27.375 49.4514-78.623 73.9378-51.249 24.4866-99.137 31.0836-106.963 14.7356-7.8258-16.3486 27.375-49.45 78.627-73.938z",
    fillRule: "evenodd",
    stroke: "#e4e4e4",
    strokeWidth: 1.267
  }), /*#__PURE__*/React.createElement("path", {
    d: "m292.525 108.404h19.1329v29.4709h-19.1329z",
    fill: "url(#a)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinesButton);
export default __webpack_public_path__ + "static/media/lines-button.266ae29aa45b729f97b4716cba61dd4e.svg";
export { ForwardRef as ReactComponent };